import { render } from "./IntFrame.vue?vue&type=template&id=447077f0"
import script from "./IntFrame.vue?vue&type=script&lang=js"
export * from "./IntFrame.vue?vue&type=script&lang=js"

import "./IntFrame.vue?vue&type=style&index=0&id=447077f0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__